export default __webpack_public_path__ + "static/media/SoloLearn-Jquery.17b47a2c.webp";